import { BankingValueObjectsCardStatusEnum } from 'generated/resources/graphql'

export const isCanceled = (card: { status: BankingValueObjectsCardStatusEnum }): boolean => {
  return card.status === 'canceled'
}
